<template src="./invoicePopupComponent.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "invoicePopupComponent",
        props: ["guestInfo", "roomInfo", "additionalEmails", "folioItemsDetails", "actualMyValue", "selectedLedger", "Reservation_Status", "balanceTransferDetails", "parentComp", "getTotalAmount",
            "totalAmountVal", "totalBalanceTransfer", "totalTaxVal", "corporateDetails", "corporateEmail", "corporatePhoneNo", "companyProfileId", "clientId", "isMasterFolioAvailable", "selectedInvoiceObj"],
        data() {
            return {
                DetailedOrConsolidated: null,
                invoiceDetails: {},
                emailList: [],
                apiUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : ""),
            }
        },
        methods: {
            getGuestAddress(guestDetail) {
                const {  CityName, StateName, ZipCode } = guestDetail;
                const addressArr = [ CityName, StateName, ZipCode].filter(Boolean);
                return addressArr.join(", ");
            },
            getCorporateDetails(corporateDetails){
                const { CityName, StateName, PostalCode } = corporateDetails;
                const addressArr = [CityName, StateName, PostalCode].filter(Boolean);
                return addressArr.join(", ");
            },
            getPropertyAddress(propertyDetail) {
                const {cityName, stateName, ZipCode } = propertyDetail;
                const addressArr = [cityName, stateName, ZipCode].filter(Boolean);
                return addressArr.join(", ");
            },
            getClientAddress(clientDetail) {
                const { ClientCity, ClientState, ClientZipCode } = clientDetail;
                const addressArr = [ClientCity, ClientState, ClientZipCode].filter(Boolean);
                return addressArr.join(", ");
            },
            getFolioInvoice(value) {
                let vm = this;
                // console.log("vm.guestInfo.ReservationId---",vm.guestInfo.ReservationId);
                vm.DetailedOrConsolidated = value;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetFolioLedgerTransDetails_Invoice",
                    params: {
                        FunctionId: null,
                        ReservationId: vm.guestInfo.ReservationId,
                        companyProfileId: vm.companyProfileId,
                        folioId: vm.selectedInvoiceObj.length ? vm.selectedInvoiceObj[0].FolioId : null
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in GetFolioLedgerTransDetails_Invoice", err);
                            return;
                        }
                        if (response) {
                            console.log(
                                "result in GetFolioLedgerTransDetails_Invoice",
                                response
                            );
                            vm.invoiceDetails = response;
                            for (var i in vm.additionalEmails) {
                                if (!vm.additionalEmails[i].Emailaddress) {
                                    vm.additionalEmails.splice(i, 1);
                                }
                            }
                            if (vm.additionalEmails.length == 0) {

                                vm.additionalEmails.push({ ReservationId: "", Emailaddress: "" });
                            }
                        }
                    },
                });
            },
            closeInvoicePopup(){
                console.log("account doc click")
                $(".modal-backdrop.fade.in").remove();
                $(".modal-backdrop.fade.show").remove();
            },
            closeEmailDropdown() {
                let vm = this;
                vm.emailList = [];
                // vm.showEmailDropdown = false;
            },
            sendPdfEmail() {
                let vm = this;
                if (vm.emailList[0] == "" || vm.emailList[0] == null) {
                    vm.$store.dispatch("toastr", {
                        type: "warning",
                        header: "Warning",
                        message: "Please save guest email to send Invoice.",
                    });
                    return;
                }
                vm.isModalVisible = false;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "sendInvoiceMail",
                    params: {
                        invoiceDetails: vm.invoiceDetails,
                        imgUrl: vm.apiUrl + "/downloadImage/",
                        email: vm.emailList,
                        folioItemSummary: vm.folioItemsDetails,
                        DetailedOrConsolidated: vm.DetailedOrConsolidated,
                        ShowTaxdetailsonDetailedInvoice:
                            vm.guestInfo.ShowTaxdetailsonDetailedInvoice,
                        ShowPolicyonDetailedInvoice: vm.guestInfo.ShowPolicyonDetailedInvoice,
                        parentComp: vm.parentComp,
                        balanceTransferDetails: vm.balanceTransferDetails,
                        totalBalanceTransfer: vm.totalBalanceTransfer,
                        selectedInvoiceObj: vm.selectedInvoiceObj[0],
                        isMasterFolioAvailable: vm.isMasterFolioAvailable,
                        additionalCompanyDetails: {
                            createdTransferDate: vm.balanceTransferDetails && vm.balanceTransferDetails[0].CreatedDate,
                            invoiceNo: vm.balanceTransferDetails && vm.balanceTransferDetails[0].QuickbookInvoiceNo && vm.balanceTransferDetails[0].QuickbookInvoiceNo != null ? vm.balanceTransferDetails[0].QuickbookInvoiceNo : vm.balanceTransferDetails[0].InvoiceNo,
                            corporateAddress: vm.corporateDetails.Address,
                            corporateCity: vm.corporateDetails.CityName,
                            corporateState: vm.corporateDetails.StateName,
                            corporateCountry: vm.corporateDetails.CountryName,
                            postalCode: vm.corporateDetails.PostalCode,
                            companyName: vm.corporateDetails.GuestFirstName,
                            companyEmail: vm.corporateEmail && vm.corporateEmail[0].Emailaddress,
                            companyPhnNo: vm.corporatePhoneNo && vm.corporatePhoneNo[0].PhoneNumber,
                            actualTransferDate: vm.balanceTransferDetails && vm.balanceTransferDetails[0].DateEffective,
                        }

                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("err in sendInvoiceMail", err);
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "Error While sending Invoice mail!",
                            });
                            return;
                        }
                        if (response) {
                            console.log("response in sendPdf", response);
                            vm.emailList = [];
                            if (response.errorMessage == "") {
                                vm.$store.dispatch("toastr", {
                                    type: "success",
                                    header: "Success!",
                                    message: "Email Sent Succesfully!",
                                });
                            } else {
                                vm.$store.dispatch("toastr", {
                                    type: "error",
                                    header: "Error",
                                    message: "Error While sending Invoice mail!",
                                });
                            }
                        }
                    },
                });
            },
            imageURLS(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmount("$", amount);
            },
            formatDate(date) {
                console.log("date====>", date);
                let vm = this;
                return moment(date).format("DD MMM YYYY");
            },
            formatInvoiceUtcDate(date){
                let vm = this;
                return moment.utc(date).format("DD MMM YYYY");
            },
            getLastTwoDigits(date) {
                let vm = this;
                return date.toString().substr(-2);
            },
            propagation(event) {
                event.stopPropagation();
            },
            sharePdf() {
                let vm = this;

                if (vm.corporateEmail.length == 1) {
                    vm.emailList = vm.corporateEmail[0].Emailaddress.split();
                    vm.sendPdfEmail();
                }

            },
            pdfDownload(ReservationId) {
                const {
                    actualMyValue,
                    selectedLedger,
                    apiUrl,
                    DetailedOrConsolidated,
                    guestInfo,
                    companyProfileId,
                    clientId,
                    parentComp,
                    balanceTransferDetails,
                    corporateDetails,
                    corporateEmail,
                    corporatePhoneNo,
                    totalBalanceTransfer,
                    isMasterFolioAvailable,
                    selectedInvoiceObj
                } = this;
                const additionalCompanyDetails = {
                    createdTransferDate: balanceTransferDetails ? balanceTransferDetails[0].CreatedDate : null,
                    invoiceNo: balanceTransferDetails && balanceTransferDetails[0].InvoiceNo && balanceTransferDetails[0].InvoiceNo != null ? balanceTransferDetails[0].InvoiceNo : '',
                    corporateAddress: corporateDetails.Address,
                    corporateCity: corporateDetails.CityName,
                    corporateState: corporateDetails.StateName,
                    corporateCountry: corporateDetails.CountryName,
                    postalCode: corporateDetails.PostalCode,
                    companyName: corporateDetails.GuestFirstName,
                    companyEmail: corporateEmail && corporateEmail[0].Emailaddress,
                    companyPhnNo: corporatePhoneNo && corporatePhoneNo[0].PhoneNumber
                }

                const form = document.createElement("form");

                const createInput = (name, value, hidden = true) => {
                    const input = document.createElement("input");
                    input.name = name;
                    input.value = value;
                    input.hidden = hidden;
                    return input;
                };

                const appendInput = (name, value, hidden = true) => {
                    form.appendChild(createInput(name, value, hidden));
                };

                appendInput("ReservationId", ReservationId);
                appendInput("ClientId", clientId);
                appendInput("companyProfileId", companyProfileId);
                appendInput("imgUrl", `${apiUrl}/downloadImage/`);
                appendInput("ledgerAccountId", selectedLedger?.ledgerAccountID || null);
                appendInput("Amount", selectedLedger?.defaultAmount || selectedLedger?.TaxAmount || null);
                appendInput("DateEffective", selectedLedger ? moment(selectedLedger.dateEffective).format("YYYY-MM-DD") : null);
                appendInput("IsFolioEdit", selectedLedger && selectedLedger.dateEffective != null ? 1 : 0);
                appendInput("DetailedOrConsolidated", DetailedOrConsolidated);
                appendInput("ShowTaxdetailsonDetailedInvoice", guestInfo.ShowTaxdetailsonDetailedInvoice);
                appendInput("ShowPolicyonDetailedInvoice", guestInfo.ShowPolicyonDetailedInvoice);
                appendInput("invoiceType", parentComp);
                appendInput("companyDetails", JSON.stringify(additionalCompanyDetails));
                appendInput("balanceTransferDetails", JSON.stringify(balanceTransferDetails));
                appendInput("totalBalanceTransfer", JSON.stringify(selectedInvoiceObj[0]));
                appendInput("isMasterFolioAvailable", isMasterFolioAvailable);
                appendInput("folioId", selectedInvoiceObj[0].FolioId);



                form.method = "POST";
                form.action = `${this.$store.state.reportHttpUrl}/FolioInvoice`;

                document.body.appendChild(form);
                form.submit();
            },

        },
        created() {

        },
        watch: {
            guestInfo(newPropValue, oldPropValue) {
                // This will be called whenever the 'myProp' prop changes
                // Perform actions based on the new value of the prop
                this.getFolioInvoice(newPropValue.DefaultInvoiceType)
            }
        },
        computed: {},
        mounted() {
            let vm = this;
            vm.getFolioInvoice(vm.guestInfo.DefaultInvoiceType)
            $(document).click(function (e) {
                console.log("invocie popup doc click")
                // $("#invoiceToBePrinted").removeClass("show")
                // $(".menuMaskRevSum").hide();
                // $(".modal-backdrop").remove();
            })
        }
    }

</script>